/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsOverviewCampaignRowDataStatusSchema = z.enum([
	'draft',
	'review',
	'publishing',
	'active',
	'completed',
])

export type AnalyticsOverviewCampaignRowDataStatusSchema = z.infer<typeof analyticsOverviewCampaignRowDataStatusSchema>
